
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const AuthStore = namespace("Auth");

@Component({})
export default class LoginRequiredComponent extends Vue {

  @AuthStore.Getter
  private getLoginDialogStatus!: any;

  private handleShowLogin() {
    this.getLoginDialogStatus.visible = true;
  }

}
